import { SYSTEM_ATTRIBUTE_PROPERTY } from "~/core/constants/attributes";

import type { Opportunity } from "../types/common";

export const mapOpportunityAttributeData = (
  opportunities: Opportunity[] | undefined,
): Opportunity[] => {
  if (!opportunities) return [];

  return opportunities.map(opportunityData => {
    opportunityData[SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_NAME] =
      opportunityData.name;
    opportunityData[SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_ACCOUNT] =
      opportunityData.account_name;
    opportunityData[SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_CONTACT] =
      opportunityData.contact_email;
    opportunityData[SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_STAGE] =
      opportunityData.stage_name;
    opportunityData[SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_CLOSE_DATE] =
      opportunityData.close_date;
    opportunityData[SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_DEAL_SIZE] =
      opportunityData.amount;
    opportunityData[SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_OTHER_STAKEHOLDERS] =
      opportunityData.additional_contacts;
    opportunityData[SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_NEXT_STEP] =
      opportunityData.next_steps;
    opportunityData[SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_OWNER] =
      opportunityData.owner_name;
    opportunityData[SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_PROBABILITY] =
      opportunityData.probability;
    opportunityData[SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_NEXT_ACTION_DATE] =
      opportunityData.next_action_date;
    opportunityData[SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_CREATION_DATE] =
      opportunityData.created_at;

    return opportunityData;
  });
};
